import { CapaQuotationDetailedServiceType } from '@generated/graphql';
import Assets from '../Assets';

export default [
  {
    id: 1,
    name: '일반 사출',
    src: Assets.Molding.NormalImage,
    serviceEnum: CapaQuotationDetailedServiceType.InjectionMolding,
    url:
      'https://capa.ai/blog/posts/%EC%82%AC%EC%B6%9C-%EA%B8%88%ED%98%95-%EC%B4%9D%EC%A0%95%EB%A6%AC-%EC%96%91%EC%82%B0%EC%9D%84-%EC%9C%84%ED%95%9C-%EA%B8%B0%EA%B5%AC-%EC%84%A4%EA%B3%84%EC%99%80-%EC%82%AC%EC%B6%9C-%EC%84%B1%ED%98%95'
  },
  {
    id: 2,
    name: '이중 사출',
    src: Assets.Molding.DoubleImage,
    serviceEnum: CapaQuotationDetailedServiceType.DoubleShotInjectionMolding,
    url:
      'https://capa.ai/blog/posts/%EC%82%AC%EC%B6%9C-%EA%B8%88%ED%98%95-%EC%B4%9D%EC%A0%95%EB%A6%AC-%EC%96%91%EC%82%B0%EC%9D%84-%EC%9C%84%ED%95%9C-%EA%B8%B0%EA%B5%AC-%EC%84%A4%EA%B3%84%EC%99%80-%EC%82%AC%EC%B6%9C-%EC%84%B1%ED%98%95'
  },
  {
    id: 3,
    name: '블로우 사출',
    src: Assets.Molding.BlowImage,
    serviceEnum: CapaQuotationDetailedServiceType.BlowInjectionMolding,
    url:
      'https://capa.ai/blog/posts/%EC%82%AC%EC%B6%9C-%EA%B8%88%ED%98%95-%EC%B4%9D%EC%A0%95%EB%A6%AC-%EC%96%91%EC%82%B0%EC%9D%84-%EC%9C%84%ED%95%9C-%EA%B8%B0%EA%B5%AC-%EC%84%A4%EA%B3%84%EC%99%80-%EC%82%AC%EC%B6%9C-%EC%84%B1%ED%98%95'
  },
  {
    id: 4,
    name: '인서트 사출',
    src: Assets.Molding.InsertImage,
    serviceEnum: CapaQuotationDetailedServiceType.InsertInjectionMolding,
    url:
      'https://capa.ai/blog/posts/%EC%82%AC%EC%B6%9C-%EA%B8%88%ED%98%95-%EC%B4%9D%EC%A0%95%EB%A6%AC-%EC%96%91%EC%82%B0%EC%9D%84-%EC%9C%84%ED%95%9C-%EA%B8%B0%EA%B5%AC-%EC%84%A4%EA%B3%84%EC%99%80-%EC%82%AC%EC%B6%9C-%EC%84%B1%ED%98%95'
  },
  {
    id: 5,
    name: '추천이 필요합니다.',
    src: Assets.Molding.RecommendMolding,
    serviceEnum: CapaQuotationDetailedServiceType.Recommend,
    url:
      'https://capa.ai/blog/posts/%EC%82%AC%EC%B6%9C-%EA%B8%88%ED%98%95-%EC%B4%9D%EC%A0%95%EB%A6%AC-%EC%96%91%EC%82%B0%EC%9D%84-%EC%9C%84%ED%95%9C-%EA%B8%B0%EA%B5%AC-%EC%84%A4%EA%B3%84%EC%99%80-%EC%82%AC%EC%B6%9C-%EC%84%B1%ED%98%95'
  }
];
